export const RQ_USER_LOGIN_API = {
  url: 'api/user/login',
  method: 'POST',
  auth: false,
};

export const RQ_USER_REGISTRATION_API = {
  url: 'api/user/register',
  method: 'POST',
  auth: false,
};

export const RQ_USER_LOOOKUP = {
  url: 'api/user/lookup/all',
  method: 'GET',
  auth: true,
};

export const RQ_USER_REGISTER_ROLE = {
  url: 'api/user/register/<%= role %>',
  method: 'POST',
  auth: true,
};

export const RQ_USER_LOOKUP_ALL_ROLE = {
  url: 'api/user/lookup/<%= role %>',
  method: 'GET',
  auth: true,
};

export const RQ_GET_OTP = {
  url: 'api/otp/generate/email',
  method: 'POST',
  auth: false,
};

export const RQ_FORGOT_PASSWORD_API = {
  url: 'api/employee/forgot-password',
  method: 'PUT',          
  auth: false,
  search: true,
};

export const RQ_RESET_PASSWORD_API = {
  url: 'api/employee/reset-password',
  method: 'PUT',
  auth: false,
  search: false,
};

export const RQ_FIND_USER_BY_ID = {
  url: 'api/user/findby/<%= id %>',
  method: 'GET',
  auth: true,
};

export const RQ_UPDATE_USER = {
  url: 'api/user/update/<%= id %>',
  method: 'PUT',
  auth: true,
};

export const RQ_DELETE_USER = {
  url: 'api/user/delete/<%= id %>',
  method: 'DELETE',
  auth: true,
};
